module.exports = __webpack_public_path__ + "media/xiaoman_05_世界中心.85cca156.wav";